"use client"

import dynamic from "next/dynamic"
import { useEffect, useRef, useState } from "react"

const LanguageSelector = dynamic(
  () =>
    import("./language-selector").then((module) => module.LanguageSelector),
  { ssr: false }
)

export function DeferredLanguageSelector() {
  const hostRef = useRef<HTMLDivElement>(null)
  const [shouldLoad, setShouldLoad] = useState(false)

  useEffect(() => {
    const host = hostRef.current
    if (!host || shouldLoad) return

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry?.isIntersecting) {
          setShouldLoad(true)
          observer.disconnect()
        }
      },
      { rootMargin: "400px" }
    )
    observer.observe(host)
    return () => observer.disconnect()
  }, [shouldLoad])

  return (
    <div ref={hostRef} className="h-9 min-w-24">
      {shouldLoad ? <LanguageSelector triggerClassName="h-9 w-auto" /> : null}
    </div>
  )
}
